module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_09 (16).92294d8.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_09 (16).mp4
// module id = 791
// module chunks = 1